import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { KENDO_CARD } from '@progress/kendo-angular-layout';
import { AbstractNewComponent } from '@unity/abstract/abstract-new.component';
import { AgenciesClient, AgencyCreateDto, CreatedResponseDto } from '@unity/clients';
import { MultiselectCommunityControlComponent } from '@unity/forms/multiselect-community-control/multiselect-community-control.component';
import { TextboxControlComponent } from '@unity/forms/textbox-control/textbox-control.component';
import { TextboxPhoneControlComponent } from '@unity/forms/textbox-phone-control/textbox-phone-control.component';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionCancelSharedComponent } from '@unity/shared/composed/action-cancel-shared/action-cancel-shared.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { CardNewSharedComponent } from '@unity/shared/composed/card-new-shared/card-new-shared.component';
import { emailFormControl, phoneFormControl, stringFormControl } from '@unity/utils/form-controls';
import { QuickActions } from '@unity/utils/quick-actions';
import { FormGroupControlSchema, UnityRouteUrlTrees } from '@unity/utils/types';

class AgencyRegistrationSchema implements FormGroupControlSchema<AgencyCreateDto> {
  public name = stringFormControl();
  public code = stringFormControl();
  public contact = stringFormControl();
  public phone = phoneFormControl();
  public email = emailFormControl();
  public community_ids = new FormControl<number[]>([], { nonNullable: true });
}

@Component({
  selector: 'unity-new-agency-page',
  standalone: true,
  imports: [
    KENDO_BUTTON,
    KENDO_LOADER,
    KENDO_CARD,
    ReactiveFormsModule,
    TextboxControlComponent,
    TextboxPhoneControlComponent,
    MultiselectCommunityControlComponent,
    PageContainerComponent,
    CardNewSharedComponent,
    ActionSharedComponent,
    ActionCancelSharedComponent,
  ],
  templateUrl: './new-agency-page.component.html',
  styleUrl: './new-agency-page.component.scss',
})
export class NewAgencyPageComponent extends AbstractNewComponent<AgencyCreateDto, AgencyRegistrationSchema, CreatedResponseDto> {
  private readonly agenciesClient = inject(AgenciesClient);

  protected override readonly $contentHeader = signal('Create New Business Partner');
  protected override createResourceFn$ = (form: FormGroup<AgencyRegistrationSchema>) => this.agenciesClient.createOne(form.getRawValue());
  protected override redirectUrlFn = (response: CreatedResponseDto): UnityRouteUrlTrees => ['/business-partner', response.id];
  protected override newControlsFn(): AgencyRegistrationSchema {
    return new AgencyRegistrationSchema();
  }
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
